function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1370",
  "data-name": "Path 1370",
  d: "M725.515,898.255h-7.289a2.47,2.47,0,0,1,0-4.939h7.289a2.47,2.47,0,1,1,0,4.939Z",
  transform: "translate(-465.581 -833.637)",
  fill: "#00a0af"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1372",
  "data-name": "Path 1372",
  d: "M649.574,1034.538a17.886,17.886,0,0,1-9.038-15.556h-20.26v-98.92H607.93v111.266h20.26a17.886,17.886,0,0,0,9.037,15.556H740.258a17.765,17.765,0,0,0,6.543-6.434,17.569,17.569,0,0,0,2.2-5.912Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#f2f6f9"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2228",
  "data-name": "Rectangle 2228",
  width: 22.582,
  height: 12.346,
  transform: "translate(119.767 178.343)",
  fill: "#f2f6f9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1373",
  "data-name": "Path 1373",
  d: "M498.01,1038.87h87.338v-12.346H498.01Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#f2f6f9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1374",
  "data-name": "Path 1374",
  d: "M757.219,925.495a3.066,3.066,0,0,1-1.528-.407,14.809,14.809,0,0,0-7.334-1.94H665.883a3.087,3.087,0,0,1,0-6.173h82.474a20.986,20.986,0,0,1,10.394,2.752,3.087,3.087,0,0,1-1.532,5.768Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1375",
  "data-name": "Path 1375",
  d: "M757.223,956.62a3.088,3.088,0,0,1-1.532-5.769,14.818,14.818,0,0,0,0-25.763,3.087,3.087,0,0,1,3.06-5.362,20.991,20.991,0,0,1,0,36.487A3.068,3.068,0,0,1,757.223,956.62Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1376",
  "data-name": "Path 1376",
  d: "M751.57,987.732a3.087,3.087,0,0,1-1.532-5.767,15.024,15.024,0,0,0,5.435-5.335,14.853,14.853,0,0,0-5.441-20.42,3.087,3.087,0,0,1,3.072-5.355,21,21,0,0,1,7.674,28.931,21.209,21.209,0,0,1-7.68,7.54A3.064,3.064,0,0,1,751.57,987.732Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1377",
  "data-name": "Path 1377",
  d: "M745.915,1018.857a3.087,3.087,0,0,1-1.532-5.767,14.841,14.841,0,0,0,5.415-5.333,14.843,14.843,0,0,0-5.42-20.434,3.086,3.086,0,1,1,3.07-5.355,21,21,0,0,1-.005,36.483A3.064,3.064,0,0,1,745.915,1018.857Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1378",
  "data-name": "Path 1378",
  d: "M740.258,1049.97H637.227a3.093,3.093,0,0,1-1.528-.405,21.036,21.036,0,0,1-10.367-15.15h-17.4a3.087,3.087,0,0,1,0-6.174h20.26a3.086,3.086,0,0,1,3.086,3.087,14.853,14.853,0,0,0,6.811,12.47H739.4a14.834,14.834,0,0,0,1.679-23.691,14.535,14.535,0,0,0-2.333-1.645,3.086,3.086,0,0,1,3.021-5.383,20.7,20.7,0,0,1,3.341,2.351,20.993,20.993,0,0,1-3.33,34.139A3.088,3.088,0,0,1,740.258,1049.97Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1379",
  "data-name": "Path 1379",
  d: "M672.957,923.148a3.086,3.086,0,0,1-3.086-3.086V861.626a14.822,14.822,0,0,0-29.644-.073c.084,1.672,1.05,21.752-.035,28.815-1.218,8.027-9.235,29.837-9.575,30.76a3.086,3.086,0,0,1-2.9,2.02H607.93a3.087,3.087,0,1,1,0-6.173h17.628c2.026-5.627,7.609-21.458,8.531-27.539,1.016-6.606-.02-27.445-.031-27.654,0-.052,0-.1,0-.156a20.995,20.995,0,0,1,41.99,0v58.436A3.087,3.087,0,0,1,672.957,923.148Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1380",
  "data-name": "Path 1380",
  d: "M607.93,1034.415H585.348a3.087,3.087,0,1,1,0-6.174h19.495V923.148H585.348a3.087,3.087,0,1,1,0-6.173H607.93a3.086,3.086,0,0,1,3.086,3.087v111.266A3.086,3.086,0,0,1,607.93,1034.415Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1381",
  "data-name": "Path 1381",
  d: "M585.348,1041.957H498.01v-6.173h84.251V915.6H498.01v-6.173h87.338a3.086,3.086,0,0,1,3.087,3.086V1038.87A3.087,3.087,0,0,1,585.348,1041.957Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2229",
  "data-name": "Rectangle 2229",
  width: 87.338,
  height: 6.173,
  transform: "translate(32.429 152.675)",
  fill: "#cbd2d9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1382",
  "data-name": "Path 1382",
  d: "M556.828,1029.364a11.729,11.729,0,1,1,11.729-11.729A11.743,11.743,0,0,1,556.828,1029.364Zm0-17.285a5.556,5.556,0,1,0,5.556,5.556A5.562,5.562,0,0,0,556.828,1012.079Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#cbd2d9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1383",
  "data-name": "Path 1383",
  d: "M762.2,898.255H736.049a2.47,2.47,0,1,1,0-4.939H762.2a2.47,2.47,0,0,1,0,4.939Z",
  transform: "translate(-465.581 -833.637)",
  fill: "#00a0af"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1384",
  "data-name": "Path 1384",
  d: "M698.173,1069.006H672.02a2.469,2.469,0,1,1,0-4.938h26.153a2.469,2.469,0,1,1,0,4.938Z",
  transform: "translate(-487.581 -840.637)",
  fill: "#00a0af"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1385",
  "data-name": "Path 1385",
  d: "M510.938,965.211H483.992a2.469,2.469,0,0,1,0-4.938h26.946a2.469,2.469,0,0,1,0,4.938Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#00a0af"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1386",
  "data-name": "Path 1386",
  d: "M495,952.94H468.051a2.469,2.469,0,1,1,0-4.938H495a2.469,2.469,0,0,1,0,4.938Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#00a0af"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1387",
  "data-name": "Path 1387",
  d: "M513.306,952.94h-7.891a2.469,2.469,0,0,1,0-4.938h7.891a2.469,2.469,0,0,1,0,4.938Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#00a0af"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1388",
  "data-name": "Path 1388",
  d: "M607.7,887.066h-6.174a2.469,2.469,0,0,1,0-4.939H607.7a2.469,2.469,0,0,1,0,4.939Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#00a0af"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1389",
  "data-name": "Path 1389",
  d: "M592.886,887.066H577.737a2.469,2.469,0,1,1,0-4.939h15.149a2.469,2.469,0,0,1,0,4.939Z",
  transform: "translate(-465.581 -840.637)",
  fill: "#00a0af"
});

var SvgThankYou = function SvgThankYou(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration_-_Thanks",
    "data-name": "Illustration - Thanks",
    width: 303.777,
    height: 228.369,
    viewBox: "0 0 303.777 228.369",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThankYou, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thankYou.26458b66.svg";
export { ForwardRef as ReactComponent };